import { flags, FlagCountryCode } from "./svgs";

export type { FlagCountryCode };

interface FlagIconProps {
  countryCode: FlagCountryCode;
  widthPx: number;
  className?: string;
}

function FlagIcon({ countryCode, widthPx, ...rest }: FlagIconProps) {
  if (!countryCode) return null;

  const aspectRatio = 0.75;
  const flagSvg = flags[countryCode.toLowerCase() as keyof typeof flags];

  if (!flagSvg) {
    return null;
  }

  return (
    <img
      src={flagSvg}
      style={{ width: `${widthPx}px`, height: `${widthPx * aspectRatio}px` }}
      alt={countryCode}
      {...rest}
    />
  );
}

export { FlagIcon };
